/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type NetworkFilterSchemaMinStrength = typeof NetworkFilterSchemaMinStrength[keyof typeof NetworkFilterSchemaMinStrength];


export const NetworkFilterSchemaMinStrength = {
  low: 'low',
  medium: 'medium',
  high: 'high',
} as const;
